let view = null;

export default {
	namespace: 'template-home',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: HomeView } = await import(/* webpackChunkName: "home-view" */ '../../templates/HomeView');
		view = new HomeView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
